/**
 * Resolves the router basename (mount prefix) for the current URL.
 *
 * PPUI is mounted under a known deployment prefix (`/v2`, `/checkout`, or `/`).
 * Handshake entry is at site-root `/handshake?checkoutId=…` (basename `/`);
 * plan selection after the dwell still navigates into `/v2/`.
 * We must only return known mount prefixes; inventing compound prefixes like
 * `/v2/checkout` causes hard-navs to land on `/v2/checkout/?…`, which 404s.
 */
const KNOWN_MOUNT_PREFIXES = ["/v2", "/checkout"] as const;

export function detectAppBasename(
  pathname: string = window.location.pathname,
): string {
  for (const prefix of KNOWN_MOUNT_PREFIXES) {
    if (pathname === prefix || pathname.startsWith(`${prefix}/`)) {
      return prefix;
    }
  }

  return "/";
}

/**
 * The base path (always trailing-slashed) to redirect into after the handshake,
 * e.g. "/checkout/", "/v2/", or "/". Authed customers are sent into the mount
 * root (plan selection), never into a nested handshake-only segment.
 */
export function appBasePath(basename: string): string {
  return basename && basename !== "/" ? `${basename}/` : "/";
}
